import { defineScope } from '@dataroom/interaction';
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';

type ConflictActions = {
  move: (delta: number) => void;
  toggle: () => void;
  resolve: (action: 'keep' | 'use' | 'lock') => void;
  canResolve: boolean;
  canSelect: boolean;
  hasRows: boolean;
};
export const conflictScope = defineScope<ConflictActions>({
  id: 'quality.conflicts',
  kind: 'list',
  title: () => t('quality.tab.conflicts'),
});
export default defineAppCommands({
  id: 'quality.conflicts',
  loadTitles: () => import('./messages'),
  scopes: [conflictScope],
  commands: [
    {
      id: 'quality.conflicts.next',
      title: () => t('quality.next'),
      shortcut: 'j',
      scope: conflictScope,
      when: (c) => c.hasRows,
      run: (c) => c.move(1),
      repeat: true,
    },
    {
      id: 'quality.conflicts.previous',
      title: () => t('quality.previous'),
      shortcut: 'k',
      scope: conflictScope,
      when: (c) => c.hasRows,
      run: (c) => c.move(-1),
      repeat: true,
    },
    {
      id: 'quality.conflicts.select',
      title: () => t('quality.toggleSelection'),
      shortcut: 'x',
      scope: conflictScope,
      when: (c) => c.hasRows && c.canSelect,
      run: (c) => c.toggle(),
    },
    ...(['keep', 'use', 'lock'] as const).map((action, i) => ({
      id: `quality.conflicts.${action}`,
      title: () => t(`quality.${action}`),
      shortcut: ['1', '2', 'l'][i]!,
      scope: conflictScope,
      when: (c: ConflictActions) => c.hasRows && c.canResolve,
      run: (c: ConflictActions) => c.resolve(action),
    })),
  ],
});
